<template>
  <div>
    <nav-bar></nav-bar>    
    <section class="resturant-main tab-content header-top">
      <!-- Search Bar -->
      <div class="searchbar-item mastr-search">
        <div class="container">
          <div class="row flex-wrap">
            <div class="col order-lg-2 order-1 p-0">
              <div class="search-bar-main w-100 d-flex align-items-center position-relative">
                <i class="fas fa-search search-icon"></i>
                <input 
                  type="search" 
                  id="search" 
                  v-model="search" 
                  name="search" 
                  class="srch-itm"
                  :placeholder="$t('Search')" 
                  v-on:keyup="handleSearch" 
                  autocomplete="off"
                >
                <router-link :to="{ name: 'home' }" class="srchclose" @click="clearSearch">
                  <svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" class="sc-64ptou-0 faawBe nukjgu-4 kztNWe">
                    <g stroke-width="2" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M13 1L1 13M1 1l12 12"></path>
                    </g>
                  </svg>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Results Section -->
      <div class="container results-container">
        <div class="row">
          <div class="col-md-12">
            <div class="menuitems-main">
              <div class="main-content">
                <div class="menulength">
                  <section class="srcsectin">
                    
                    <!-- Loading Skeleton -->
                    <div v-if="isLoading">
                      <div class="media-itms">
                        <div class="item_detail" v-for="index in 6" :key="index">
                          <div class="media">
                            <a href="javascript:void(0)" class="btn btn-default show-modal">
                              <div class="media-body">
                                <h5 class="mt-0 me-5 item-name">
                                  <skeleton-loader-vue type="string" width="35%" height="20px" />
                                </h5>
                                <p class="mb-0 mt-2 item-descr">
                                  <skeleton-loader-vue type="string" width="90%" height="16px" />
                                </p>
                                <p class="mb-0 mt-1 item-descr">
                                  <skeleton-loader-vue type="string" width="75%" height="16px" />
                                </p>
                                <div class="prc-show mt-3">
                                  <span class="mt-2 d-inline-block item-price">
                                    <skeleton-loader-vue type="string" width="60px" height="24px" />
                                  </span>
                                </div>
                              </div>
                            </a>
                            <div class="img-btn">
                              <div class="item-img">
                                <skeleton-loader-vue width="120" height="120" class="img-cls" style="border-radius: 8px" />
                              </div>
                              <div class="pgnme-cls mt-2">
                                <div>
                                  <div class="sold-de">
                                    <div class="icus">
                                      <skeleton-loader-vue type="string" width="80px" height="32px" style="border-radius: 4px" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Search Results -->
                    <div v-else-if="products.length > 0">
                      <div 
                        v-for="restaurant in products" 
                        :key="restaurant.restaurant_menu_id" 
                        class="proditm"
                      >                   
                        <!-- Restaurant Items -->
                        <div 
                          v-if="restaurant.item && restaurant.item.length > 0"
                          class="media-itms"
                          :class="'media-itms-theme' + itemLayout"
                        >
                          <Product 
                            v-for="(item, index) in restaurant.item" 
                            :key="index" 
                            :item="item" 
                            :right="true"
                            :menuId="item.restaurant_menu_id" 
                            :restaurantID="restaurant.restaurant_id"
                            :restaurant_on_off="restaurant.restaurant_on_off" 
                            :pagename="pageName"
                            :slug="restaurant.slug" 
                            v-on:openProductDetailModal="openProductDetails"
                            :itemlayout="itemLayout"
                          />
                        </div>
                      </div>
                    </div>

                    <!-- No Results Found -->
                    <div 
                      v-else-if="showNoResults"
                      class="order-offers rest-not-found"
                    >
                      <p>{{ $t('No Item Found') }}</p>
                    </div>

                    <!-- Initial State -->
                    <div 
                      v-else-if="!search || search.length < 3"
                      class="order-offers"
                    >
                      <p>{{ $t('Enter at least 3 characters to search') }}</p>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Product Details Modal -->
    <ProductDetails 
      ref="productDetailsModal" 
      :restaurantID="selectedRestaurantId" 
      :restaurant_on_off="selectedRestaurantStatus"
      :pagename="pageName"
    />
    
    <Footer></Footer>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import { mapActions, mapGetters } from "vuex";
import Product from "@/components/Product.vue";
import Rating from "@/components/Rating.vue";
import Footer from '../components/Footer.vue';
import VueSkeletonLoader from 'skeleton-loader-vue';
import ProductDetails from "@/components/ProductDetails.vue";

export default {
  name: 'ItemSearchPage',
  
  components: {
    NavBar,
    Product,
    Rating,
    Footer,
    ProductDetails,
    'skeleton-loader-vue': VueSkeletonLoader,
  },

  data() {
    return {
      search: '',
      products: [],
      isLoading: false,
      showNoResults: false,
      selectedRestaurantId: 0,
      selectedRestaurantStatus: 0,
      pageName: 'mastersearch',
      itemLayout: '1',
      searchTimer: null,
      nearestRestaurant: null,
      locationData: {
        lat: 0,
        lng: 0,
        city: '',
        state: '',
      },
    };
  },

  computed: {
    ...mapGetters("order", ["isPickupDelivery"])
  },

  watch: {
    search: function(newValue) {
      if (newValue) {
        this.search = this.sanitizeSearchText(newValue);
      }
    },
  },

  mounted: function() {
    this.initializeSearch();
  },

  methods: {
    ...mapActions("restaurant", [
      "getSearchRestaurantItem", 
      "getItemSoldStatusList"
    ]),

    // Initialize search on page load
    initializeSearch: function() {
      var self = this;
      
      // Load location data from localStorage
      this.locationData.lat = parseFloat(localStorage.getItem("latitude")) || 0;
      this.locationData.lng = parseFloat(localStorage.getItem("longitude")) || 0;
      this.locationData.city = localStorage.getItem("city") || '';
      this.locationData.state = localStorage.getItem("state") || '';
      
      // Load saved search text
      this.search = localStorage.getItem("searchText") || "";

      // Load nearest restaurant data
      var nearestRestaurantData = localStorage.getItem('nearestRestaurant');
      if (nearestRestaurantData) {
        try {
          this.nearestRestaurant = JSON.parse(nearestRestaurantData);
        } catch (e) {
          console.error('Error parsing nearest restaurant:', e);
        }
      }

      // Perform search if there's a saved search term
      if (this.search) {
        this.searchItems(this.search);
      }

      // Load item layout setting
      setTimeout(function() {
        if (self.$auth.setting && self.$auth.setting.restaurant_item_layout) {
          self.itemLayout = self.$auth.setting.restaurant_item_layout || '1';
        }
      }, 1000);
    },

    // Handle search input with debouncing
    handleSearch: function() {
      var self = this;
      
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }
      
      this.searchTimer = setTimeout(function() {
        self.searchItems(self.search);
      }, 500);
    },

    // Main search function
    searchItems: function(searchText) {
      var self = this;
      
      // Save search text to localStorage
      localStorage.setItem('searchText', searchText);

      // Check if auth setting is available
      if (!this.$auth || !this.$auth.setting) {
        console.warn('Auth settings not loaded yet');
        return;
      }

      // Validate search text
      var sanitizedText = this.sanitizeSearchText(searchText);
      
      if (!sanitizedText || sanitizedText.length < 3) {
        this.products = [];
        this.showNoResults = false;
        return;
      }

      // Build search request data
      var brandId = this.nearestRestaurant && this.nearestRestaurant.brand_id ? this.nearestRestaurant.brand_id : undefined;
      var restaurantId = this.nearestRestaurant && this.nearestRestaurant.restaurant_id ? this.nearestRestaurant.restaurant_id : undefined;
      
      var searchParams = {
        searchtext: sanitizedText,
        date: '',
        startrime: '',
        brand_id: brandId,
        restaurant_id: restaurantId,
        vendor_id: this.$auth.getVendorId(),
        cityname: this.locationData.city,
        latitude: this.locationData.lat,
        longitude: this.locationData.lng,
        state: this.locationData.state,
        skip: 0,
        total_record: 100,
        is_langauge: this.$store.state.lang.locale,
        delivery_type_time_slots: this.isPickupDelivery
      };

      this.isLoading = true;
      this.products = [];
      this.showNoResults = false;

      // Get search results
      this.getSearchRestaurantItem(searchParams).then(function(searchResponse) {
        if (searchResponse.code !== 200 || !searchResponse.Result) {
          self.isLoading = false;
          self.showNoResults = true;
          return;
        }

        // Process items for sold status check
        var itemsToCheck = self.buildItemCheckList(searchResponse.Result);
        
        if (itemsToCheck.length === 0) {
          self.isLoading = false;
          self.showNoResults = true;
          return;
        }

        // Get item sold status
        var soldStatusParams = {
          vendor_id: self.$auth.getVendorId(),
          item_list: JSON.stringify(itemsToCheck),
          is_langauge: self.$i18n.locale
        };

        self.getItemSoldStatusList(soldStatusParams).then(function(soldStatusResponse) {
          self.isLoading = false;
          
          if (soldStatusResponse.code === 200) {
            self.products = self.mergeItemsWithStatus(
              searchResponse.Result, 
              soldStatusResponse.Result
            );
            self.showNoResults = self.products.length === 0;
          } else {
            self.showNoResults = true;
          }
        }).catch(function(error) {
          console.error('Sold status error:', error);
          self.isLoading = false;
          self.showNoResults = true;
        });

      }).catch(function(error) {
        console.error('Search error:', error);
        self.isLoading = false;
        self.showNoResults = true;
      });
    },

    // Build list of items to check sold status
    buildItemCheckList: function(restaurants) {
      var itemsList = [];
      
      restaurants.forEach(function(restaurant) {
        if (restaurant.item && restaurant.item.length > 0) {
          var restaurantItems = {
            restaurant_id: restaurant.restaurant_id,
            items: []
          };
          
          restaurant.item.forEach(function(item) {
            restaurantItems.items.push({
              restaurant_menu_item_id: item.restaurant_menu_item_id,
              restaurant_menu_id: item.restaurant_menu_id
            });
          });
          
          itemsList.push(restaurantItems);
        }
      });
      
      return itemsList;
    },

    // Merge search results with sold status data
    mergeItemsWithStatus: function(restaurants, soldStatusData) {
      var updatedRestaurants = JSON.parse(JSON.stringify(restaurants));
      
      soldStatusData.forEach(function(statusItem) {
        var restaurantIndex = updatedRestaurants.findIndex(function(r) {
          return r.restaurant_id === statusItem.restaurant_id;
        });
        
        if (restaurantIndex !== -1 && updatedRestaurants[restaurantIndex].item) {
          var itemIndex = updatedRestaurants[restaurantIndex].item.findIndex(function(i) {
            return i.restaurant_menu_item_id === statusItem.restaurant_menu_item_id;
          });
          
          if (itemIndex !== -1) {
            updatedRestaurants[restaurantIndex].item[itemIndex].is_sold_out = statusItem.is_sold_out;
            updatedRestaurants[restaurantIndex].item[itemIndex].is_customization = statusItem.is_customization;
            updatedRestaurants[restaurantIndex].item[itemIndex].item_id = statusItem.restaurant_menu_item_id;
            updatedRestaurants[restaurantIndex].item[itemIndex].restaurant_id = statusItem.restaurant_id;
            updatedRestaurants[restaurantIndex].item[itemIndex].quantity = statusItem.quantity;
          }
        }
      });
      
      return updatedRestaurants;
    },

    // Open product details modal
    openProductDetails: function(productData) {
      this.selectedRestaurantId = productData.restaurant_id;
      this.selectedRestaurantStatus = productData.restaurant_on_off;
      
      window.$("#item-popup").modal("show");
      this.$refs.productDetailsModal.openProductModel(productData.item_id);
    },

    // Clear search and remove from localStorage
    clearSearch: function() {
      localStorage.removeItem('searchText');
      this.search = '';
      this.products = [];
      this.showNoResults = false;
    },

    // Remove special characters from search text
    sanitizeSearchText: function(text) {
      return text.replace(/[^\w\s]/gi, "").trim();
    },
  },
};
</script>

<style scoped>
/* Results container spacing for fixed search bar */
.results-container {
  margin-top: 100px;
  padding-left: 0px !important;
  padding-right: 0px !important;
  /* padding-top: 20px; */
}

input.srch-itm {
  width: 100%;
  padding: 9px 4px 9px 40px;
  background-color: #fff;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.01);
}

.search-bar-main i {
  position: absolute;
  top: 48%;
  left: 15px;
  translate: 0 -50%;
  color: var(--theme-font-primary);
  opacity: 0.5;
  font-size: 15px;
}

input[type="search"]::-webkit-search-cancel-button {
  -webkit-appearance: none;
  height: 1em;
  width: 1em;
  border-radius: 50em;
  background: url(https://pro.fontawesome.com/releases/v5.10.0/svgs/solid/times-circle.svg) no-repeat 50% 50%;
  background-size: contain;
  opacity: 0;
  pointer-events: none;
  padding-left: 20px;
}

input[type="search"]:focus::-webkit-search-cancel-button {
  opacity: .3;
  pointer-events: all;
}

input[type="search"].dark::-webkit-search-cancel-button {
  filter: invert(1);
}

.skel-img-cls {
  width: 120px;
  height: 120px;
  margin-right: 7px;
  border-radius: 5px !important;
}
</style>